/// <reference path="../types/index.d.ts" />

import '../client_forms/tcadestevent/style.css';
import FormStructure from './tcadestevent/form_structure';

export default FormStructure;